import React from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'
import css from 'common/loading/circle/styles'

const Loading = () => <CircularProgress className={css.customized} />

export default Loading
